<template>
    <div class="d-flex flex-column align-items-center pt-2">
        <img alt="" src="/img/hcpay/shopping-basket.svg" class="cartIcon img-responsive">
        <div v-if="!transaction.partnerId" class="font-xs text-secondary mt-4 mb-2">
            <span>Total amount from</span>
            <span class="text-capitalize">{{ transaction.merchantName }}</span>
        </div>
        <div v-else class="font-xs text-secondary mt-4 mb-2">
            <span>Total amount from</span>
            <span class="text-capitalize">{{ transaction.partnerName }}</span> - <span class="text-capitalize">{{ transaction.merchantName }}</span>
        </div>
        <span class="font-lg font-weight-bold text-gray-dk text-uppercase">{{currency}} {{formattedAmount}}</span>
    </div>
</template>
<script>
export default {
    props:{
        transaction: {
            type: Object,
            default: ''
        },
        merchantName: {
            type: String,
            default: 'merchant'
        },
        partnerName: {
            type: String,
            default: 'Paynamics'
        },
        currency: {
            type: String,
            default: '₱'
        },
        amount: {
            type: Number,
            default: 0.00
        }
    },
    computed: {
        formattedAmount: {
            get() {
                let val = (this.amount/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        }
    }
}
</script>
<style scoped>
    .cartIcon {
        height: auto;
        width: 2.5rem;
    }
</style>